module.exports = __webpack_public_path__ + "img/imagen5.0fbc2b65.png";